import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputSelectControlliCostumComponent } from '../input-select-controlli-costum/input-select-controlli-costum.component';
import { PuntiCampionamentoService } from '../../../punti-campionamento/punti-campionamento.service';
import { PuntiCampionamentoSearchTemplateComponent } from '../../../punti-campionamento/components/punti-campionamento-search-template/punti-campionamento-search-template.component';
import { ControlliService } from '../../controlli.service';

@Component({
  selector: 'app-punti-campionamento-controlli-input-select',
  standalone: true,
  imports: [
    CommonModule,
    InputSelectControlliCostumComponent,
    PuntiCampionamentoSearchTemplateComponent
  ],
  templateUrl: './punti-campionamento-controlli-input-select.component.html',
  styleUrl: './punti-campionamento-controlli-input-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PuntiCampionamentoControlliInputSelectComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() name: string = '';
  @Output() datoSelectedInput: EventEmitter<any> = new EventEmitter<any>();
  puntiCampionamento = this.puntiCampionamentoService.query.list;
  searchTemplate = PuntiCampionamentoSearchTemplateComponent;

  constructor(
    @Inject(PuntiCampionamentoService) public puntiCampionamentoService: PuntiCampionamentoService,

  ) {}

  ngOnInit(): void {
    this.getRegioni();
  }

  getRegioni() {
    this.puntiCampionamentoService.query.get();
  }
  ngOnDestroy(): void {
    this.puntiCampionamentoService.query.store.setKey('list', [])
  }
  chekDataSelected(e:any){
    this.datoSelectedInput.emit(e)
    
  }
}
